import { render, staticRenderFns } from "./EventiRecenti.vue?vue&type=template&id=6ad29791&scoped=true&"
import script from "./EventiRecenti.vue?vue&type=script&lang=js&"
export * from "./EventiRecenti.vue?vue&type=script&lang=js&"
import style0 from "./EventiRecenti.vue?vue&type=style&index=0&id=6ad29791&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad29791",
  null
  
)

export default component.exports